import React from 'react';
import { cn } from '../../lib/utils';

export const StatusBadge = ({ status, className }: { status: string; className?: string }) => {
  const statusColors: Record<string, string> = {
    open: "bg-blue-50 text-blue-700 border-blue-200",
    in_progress: "bg-amber-50 text-amber-700 border-amber-200",
    resolved: "bg-green-50 text-green-700 border-green-200",
    closed: "bg-slate-50 text-slate-500 border-slate-200",
    pending: "bg-yellow-50 text-yellow-700 border-yellow-200",
    confirmed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    cancelled: "bg-red-50 text-red-600 border-red-200",
  };
  return (
    <span className={cn("px-2.5 py-0.5 rounded-full text-xs font-medium border", statusColors[status.toLowerCase()] || "bg-gray-100 text-gray-800", className)}>
      {status}
    </span>
  );
};
